import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Link, useHistory, useParams, useRouteMatch } from "react-router-dom"
import { Button, Form, Input, Row, Col, Switch, Select, Skeleton, Space, notification } from "antd"
// import TextArea from "antd/lib/input/TextArea"
import { LeftOutlined } from "@ant-design/icons"
import { fetchBillableAccountNote, selectBillableAccountNote, setBillableAccountNote, submitBillableAccountNote } from "../billableAccountNotesSlice"
import { useWatch } from "antd/lib/form/Form"
import requestNotification from "../../../lib/notifications"

const { Option } = Select
const { TextArea } = Input

export default function BillableAccountNotesForm({ actionName }) {
    const { url } = useRouteMatch()
    const [form] = Form.useForm()
    const dispatch = useDispatch()
    const history = useHistory()
    const { clientId, billableAccountId, billableAccountNoteId } = useParams()
    const noteValue = useWatch("note", form); 
    const [loaded, setLoaded] = useState(false)
    const note = useSelector(selectBillableAccountNote)

    useEffect(() => {
        if (billableAccountNoteId) {
            dispatch(fetchBillableAccountNote(clientId, billableAccountId, billableAccountNoteId))
        } else {
            dispatch(setBillableAccountNote({}))
        }
    }, [dispatch, billableAccountNoteId, form])

    useEffect(() => {
        if (note) {
            form.setFieldsValue({ note: note.note })
        }
    }, [note, form])

    const submit = async (values) => {
        const response = await dispatch(submitBillableAccountNote({ ...values, billable_account_id: billableAccountId }, billableAccountNoteId))

        if (response.success) {
            history.push(`/clients/${clientId}/billable_accounts/${billableAccountId}/notes`)
        }

        requestNotification(response)
    }

    return (
        <div id="user-form-container">
            <div className="card-body-heading">
                <div className="badged-header">
                    <h2>{billableAccountNoteId ? "Edit" : "New"} Note</h2>
                    {/* <div className="badge">{notes.length}</div> */}
                </div>
            </div>
            <Link to={`/clients/${clientId}/billable_accounts/${billableAccountId}/notes`}>
                <LeftOutlined />
                Go Back
            </Link>
            <Skeleton active loading={false}>
                <Form
                    form={form}
                    initialValues={{ ...note }}
                    onFinish={submit}
                    layout="vertical">
                    <div className="card">
                        <div className="card-body">
                            <Row gutter={8}>
                                <Col span={24}>
                                    <div className="text-right text-sm" style={{ color: 'white' }}>{noteValue?.length || 0}/356 characters</div>
                                    <Form.Item label="Note" name="note">
                                        <TextArea rows={4} maxLength={356}/>
                                    </Form.Item>
                                </Col>
                                <Col span={24}>
                                    <Form.Item className="mr-5">
                                        <Button type="primary" htmlType="submit">
                                            {billableAccountNoteId ? "Update" : "Submit"}
                                        </Button>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </Form>
            </Skeleton>
        </div>
    )
}